(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bpets-bestsellers-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestsellers(root) {
      if (!root || root.dataset.bpetsInit === 'true') return;
      root.dataset.bpetsInit = 'true';

      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');

      function updateNavState(panel) {
        var track = panel.querySelector('[data-track]');
        var prev = panel.querySelector('[data-nav-prev]');
        var next = panel.querySelector('[data-nav-next]');
        if (!track) return;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function getScrollAmount(track) {
        var firstCard = track.querySelector('.bpets-card');
        if (!firstCard) return 300;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap, 10) || 18;
        return (firstCard.offsetWidth + gap) * 2;
      }

      // Tab switching
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = parseInt(tab.dataset.tabIndex, 10);

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var activePanel = panels[index];
          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.removeAttribute('hidden');
            var track = activePanel.querySelector('[data-track]');
            if (track) {
              track.scrollLeft = 0;
              updateNavState(activePanel);
            }
          }
        });
      });

      // Nav arrows + scroll state per panel
      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-track]');
        var prev = panel.querySelector('[data-nav-prev]');
        var next = panel.querySelector('[data-nav-next]');
        if (!track) return;

        if (prev) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', function () {
          updateNavState(panel);
        }, { passive: true });

        updateNavState(panel);
      });
    }

    function initAll(context) {
      var root = context || document;
      root.querySelectorAll('[data-bpets-bestsellers]').forEach(initBestsellers);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bpets-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.bpetsCarouselInit === 'true') return;
      root.dataset.bpetsCarouselInit = 'true';

      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-nav-prev]');
      var next = root.querySelector('[data-nav-next]');
      if (!track) return;

      function getScrollAmount() {
        var firstCard = track.querySelector('.bpets-card');
        if (!firstCard) return 300;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap, 10) || 18;
        return (firstCard.offsetWidth + gap) * 2;
      }

      function updateNavState() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateNavState();
      }, { passive: true });

      updateNavState();
    }

    function setupRelated(root) {
      if (!root) return;
      var track = root.querySelector('[data-track]');
      if (!track) return;

      var url = root.dataset.recommendationsUrl;

      // Sin URL: conservar la capa server-side (coleccion) y solo activar el carrusel.
      if (!url) {
        initCarousel(root);
        return;
      }

      // Pedir las recomendaciones NATIVAS de Shopify. Si llegan productos reales,
      // reemplazan la capa server-side. Si falla o no hay, se conserva lo server-side.
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var freshTrack = doc.querySelector('[data-bpets-related] [data-track]');
          if (
            freshTrack &&
            freshTrack.innerHTML.trim().length &&
            !freshTrack.querySelector('.bpets-card--placeholder')
          ) {
            track.innerHTML = freshTrack.innerHTML;
          }
          if (window.bpetsUpdateShipping) window.bpetsUpdateShipping(root);
          if (window.bpetsInitCarousels) window.bpetsInitCarousels(root);
          initCarousel(root);
        })
        .catch(function () {
          initCarousel(root);
        });
    }

    function initAll(context) {
      var root = context || document;
      root.querySelectorAll('[data-bpets-related]').forEach(setupRelated);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
